import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { getItem } from "../utility/localStorageControl";
import { lazy, useEffect } from "react";
import HotelList from "../container/home/HotelList";
import HotelDetails from "../container/home/HotelDetails";
import Booking from "../container/Booking/Header";
import ViewCart from "../container/home/ViewCart";
import NotFound from "../container/NotFound/NotFound";
import OrderCompletePage from "../container/StaticPages/OrderCompletePage";
import HotelClosedPage from "../container/StaticPages/HotelClosedPage";
import Cancellation from "../container/Booking/cancellation";
import Terms from "../container/Booking/Terms";
import Privacy from "../container/Booking/Privacy";

function Private() {
  return (
    <Routes>
      <Route exact path={`/`} element={<HotelList />} />
      {/* /hotel without an id has nothing to show, send guests to the hotel finder */}
      <Route exact path={`/hotel`} element={<Navigate to="/" replace />} />
      <Route exact path={`/hotel/:table_id`} element={<HotelDetails />} />
      <Route exact path={`/hotel/booking`} element={<Booking />} />
      <Route
        exact
        path={`/hotel/cancellation/:table_id`}
        element={<Cancellation />}
      />
      <Route exact path={`/hotel/terms/:table_id`} element={<Terms />} />
      <Route
        exact
        path={`/hotel/privacy-policy/:table_id`}
        element={<Privacy />}
      />
      <Route exact path="/*" element={<NotFound />} />
    </Routes>
  );
}

export default Private;
